package kz.dentalcrm.app.screens.protocols.edit.mvi

import kz.dentalcrm.app.core.base.ViewEvent
import kz.dentalcrm.app.data.network.response_model.protocol_templates.ProtocolTemplate

sealed interface EditProtocolViewEvent : ViewEvent {

    data class EditProtocol(
        val naming: String,
        val code: String,
        val id: Int,
    ) : EditProtocolViewEvent

    data class DeleteProtocol(
        val treatment: ProtocolTemplate
    ) : EditProtocolViewEvent

    data object Reset : EditProtocolViewEvent
}